import React, { useEffect } from 'react';

interface FeedbackModalProps {
  tipo: 'exito' | 'error';
  mensaje: string;
  icono?: string;
  onClose: () => void;
  autoCloseDelay?: number; // en milisegundos, por defecto 3 segundos
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  tipo,
  mensaje,
  icono,
  onClose,
  autoCloseDelay = 3000
}) => {
  
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, autoCloseDelay);

    return () => clearTimeout(timer);
  }, [onClose, autoCloseDelay]);

  const getIconoConfig = () => {
    if (icono) return icono;
    return tipo === 'exito' ? '✓' : '✕';
  };

  const getColorConfig = () => {
    return tipo === 'exito' ? '#8bc34a' : '#f44336';
  };

  return (
    <div style={{ 
      padding: '50px 30px', 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      minHeight: '200px',
      justifyContent: 'center'
    }}>
      <div style={{ 
        width: '60px', 
        height: '60px', 
        backgroundColor: getColorConfig(), 
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '24px',
        fontWeight: 'bold'
      }}>
        {getIconoConfig()}
      </div>
      <p style={{ 
        margin: 0, 
        fontSize: '16px', 
        color: '#333',
        lineHeight: '1.4',
        fontWeight: '500'
      }}>
        {mensaje}
      </p>
    </div>
  );
};

export default FeedbackModal;